import * as React from 'react';

class BoxInfo extends React.Component {
    constructor(props) {
        super(props);
        this.boxOnClick = this.boxOnClick.bind(this);
        this.componentName = '[BoxInfo.jsx] ';
        this.state = {}
    }

    boxOnClick(e) {
        console.log(this.componentName + 'boxOnClick');
        if (e && e.target.id) {
            this.props.boxOnClick(e.target.id)
        } else if (e && e.currentTarget.id) {
            this.props.boxOnClick(e.currentTarget.id)
        }
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="boxInfo animated flipInY col-lg-6 col-md-6 col-sm-12 col-xs-12" id={this.props.id} onClick={this.boxOnClick} >
                <div className="tile-stats">
                    <div className="icon" id={this.props.id} onClick={this.boxOnClick} > <i className={this.props.icon}></i></div>
                    <h3 style={{marginTop: '0.5rem'}}>{this.props.headerText}</h3>
                    <div className="count mt-2 mb-2"> {this.props.numberVal}</div>
                    <p>{this.props.pText}</p>
                </div>
            </div>
        );
    }

}

export default BoxInfo;
